import * as types from './types'
import storage from '@/plugins/storage'
export default {
  [types.SET_LOCATION](state, location) {
    state.business = location
  },
  [types.SET_DEVICES](state, devices) {
    state.devices = []
    for (let element of devices) {
      state.devices.push({
        value: element.Id,
        name: element.FriendlyName,
        DeviceTypeId: element.DeviceTypeId,
        DeviceTypeDescription: element.DeviceTypeDescription
      })
    }
    storage.local.setItem(types.SESSION_DEVICES, JSON.stringify(state.devices))
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/location/mutations.js